import { Component, Inject, inject, Optional, signal } from '@angular/core';
// import { ApiRoutes, IApiResponse } from '../../../../shared/src/import-export';
import { CrudManagementService } from '../../core/services/crud-management.service';
import { TagComponent } from "../../core/shared/components/tag.component";
import { EventStatusBGPipe } from "../../core/shared/pipes/trip-statusPipe";
import { faCheck, faImage } from '@fortawesome/free-solid-svg-icons';
import { DatePipe, NgFor, NgIf, UpperCasePipe } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../../core/services/api-endpoints.service';
import { ThemeService } from '../../core/services/theme.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ViewimageComponent } from './viewimage.component';
import { IBooking } from './model';
import { ApiRoutes } from '../../core/shared/apiroutes';
import { IApiResponse } from '../../core/library/interfaces';
@Component({
  selector: 'app-booking-status',
  standalone: true,
  imports: [TagComponent, NgIf, FontAwesomeModule, MatExpansionModule, EventStatusBGPipe, UpperCasePipe, DatePipe],
  templateUrl: './booking-status.component.html',
  styleUrl: './booking.component.css'
})
export class BookingStatusComponent {

  apiService = inject(CrudManagementService);

  readonly panelOpenState = signal(false);

  themeService = inject(ThemeService);
  authService = inject(AuthService);


  _id: string;
  isError: boolean;
  errorMsg: string;
  booking: any = {};

  faCheck = faCheck;
  faImage = faImage;
  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    @Optional() public dialogRef: MatDialogRef<ViewimageComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: string, public dialog: MatDialog,
  ) {
    this.route.paramMap
      .pipe(
        map((params: ParamMap) => params.get('_id'))
      ).subscribe(x => this._id = x);
    console.log(this._id);
  }


  ngOnInit() {
    if (this._id) {
      this.apiService.get(`${ApiRoutes.singleBookings}/${this._id}`).subscribe({
        next: (response: IApiResponse<IBooking>) => {
          this.isError = response.error;
          this.setBooking(response.data);
        },
        error: (error) => {
          console.log("RES-->", error);
        }
      })
    }
  }

  setBooking = (data: IBooking) => {
    this.booking = data;
  }

  imageBaseUrl = 'http://localhost:9098'; // Adjust if needed
  imageAttachment = signal('');
  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.imageBaseUrl + url);
  }

  viewImage(v: IBooking | undefined) {
    const dialogRef = this.dialog.open(ViewimageComponent,
      {
        width: '85%',
        minHeight: '70%',
        data: v,
      });
    // dialogRef.afterClosed().subscribe(r => this.refresh());
  }
}
